import { configureStore } from "@reduxjs/toolkit";
import userMetrics from "./slices/userMetrics";

export const store = configureStore({
  reducer: {
    userMetrics,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
